import iassign from "immutable-assign";
import { ActionType } from "typesafe-actions";

// declare const __DEV__: boolean;
// iassign.freeze = __DEV__;

import { IAppConfiguration } from "../../services/api/configuration";

import { actionCreators } from "./actions";

import * as types from "./action-types";

export type Action = ActionType<typeof actionCreators>;

export interface IState {
  configuration?: IAppConfiguration;
  error?: string;
}

const INITIAL_STATE: IState = {
  configuration: undefined,
  error: undefined,
};

export function reducer(state: IState = INITIAL_STATE, action: Action): IState {
  switch (action.type) {
    case types.FETCH_CONFIGURATION_SUCCESS: {
      return iassign(state, (s) => {
        s.configuration = action.payload.config;

        return s;
      });
    }

    case types.FETCH_CONFIGURATION_FAILURE: {
      return iassign(state, (s) => {
        s.configuration = undefined;
        s.error = action.payload.error.message;

        return s;
      });
    }

    default:
      return state;
  }
}
